function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M239.4 110.5c-7.7-15.6-23.6-25.5-41-25.5H85.2c-17.4 0-33.4 9.9-41.1 25.5l-22.8 45.3v127.6h49.6V255h141.8v28.4h49.6V156.3l-22.9-45.8zM49.6 170.1h184.2v56.7H49.6v-56.7zm19.8-46.9c2.9-6.1 9-9.9 15.7-9.8h113.2c6.7 0 12.7 3.7 15.7 9.7l9.3 18.6H60.1l9.3-18.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.5 184.3H64.2v14.2c0 7.8 6.3 14.2 14.2 14.2h28.3v-14.2c0-7.9-6.3-14.2-14.2-14.2zM177.5 198.4v14.2h28.4c7.8 0 14.2-6.3 14.2-14.2v-14.2h-28.4c-7.9.1-14.2 6.4-14.2 14.2z"
})));